<template>
    <MatchMedia v-slot="{ mobile }">
        <slot :join-url="joinUrl(mobile)" />
    </MatchMedia>
</template>

<script>

import { MatchMedia } from "vue-component-media-queries";

export default {
    name: "TgpJoinUrl",
    components: {MatchMedia},
    props: {
        desktopUrl: {type: String, required: true},
        mobileUrl: {type: String, required: true},
    },

    methods: {
        joinUrl(isMobile) {
            return isMobile ? this.mobileUrl : this.desktopUrl;
        }
    },
}
</script>
